import * as _4 from 'lodash4';
import { ParseDictionaryServant } from '../../servants/parse_dictionary_servant';

export class AboutTogglesController {
  private memberFeatures: Record<string, any>;
  constructor(private appConfigModel: any) {
    this.memberFeatures = ParseDictionaryServant.transformKeys(appConfigModel.model.member_features);
  }
}
export class AboutTogglesComponent implements ng.IComponentOptions {
  public controller: object = AboutTogglesController;
  public templateUrl: string = 'capability-ng-settings/src/about/components/about_toggles/about_toggles.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/about/components/about_toggles/about_toggles.ts